import React, { Component } from 'react';
import { AreaField } from '../index';
import { getMatchId, IAlignmentsState, INIT_ALIGNMENTS, HOME, AWAY } from '../../index';
import getLineup from 'src/mundial/requests/api/getLineup';
import '../../styles/field.scss';

interface IFieldProps {
  location: string;
}
export default class Field extends Component<IFieldProps> {
    state: IAlignmentsState;
    location: string;

    constructor(props: IFieldProps) {
        super(props);
        this.state = INIT_ALIGNMENTS;
        this.location = props.location;
        this.getArrayFormation = this.getArrayFormation.bind(this);
    }

    getTotalPlayers(formation: number[]): number {
        const total = formation.reduce((a, b) => a + b, 0);
        return total;
    }

    getArrayFormation(formation: string = '') {
        const splitFormation = formation !== '' ? formation.split('-') : [];
        const formationAux = splitFormation.map((value) => parseInt(value));
        const totalPlayers = this.getTotalPlayers(formationAux);
        const finalFormation = totalPlayers === 11 ? formationAux : [1, ...formationAux];
        const arrayFormation = formationAux.length > 0 ? finalFormation : [];
        return arrayFormation;
    }

    async componentDidMount(): Promise<void> {
        const matchId = getMatchId(this.location);
        const dataLineup = await getLineup(matchId);
        this.setState({ ...dataLineup });
    }

    render() {
        const { awayLineup, homeLineup } = this.state;
        return (
            <div id="field">
                <AreaField
                    type={HOME}
                    formation={this.getArrayFormation(homeLineup.formation)}
                    players={homeLineup.players}
                />
                <AreaField
                    type={AWAY}
                    formation={this.getArrayFormation(awayLineup.formation)}
                    players={awayLineup.players}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Alignment/Field/Field.tsx